/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import Numerical from './Numerical';
import {FormattedNumber} from 'react-intl';

class NumericalButton extends React.Component {

    state: State = {
        keyboardVisible: false
    };

    static propTypes = {
        value: React.PropTypes.oneOfType([
            React.PropTypes.string,
            React.PropTypes.number
        ]).isRequired,
        className: React.PropTypes.string.isRequired,
        removedClassName: React.PropTypes.string,
        onSubmit: React.PropTypes.func.isRequired,
        nonDecimal: React.PropTypes.bool,
        stringAfter: React.PropTypes.string,
        label: React.PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);

        this.openKeyboard = this.openKeyboard.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    openKeyboard(open) {
        this.setState({keyboardVisible: open});
    }

    onSubmit(val) {
        const {onSubmit} = this.props;
        onSubmit(val);
        this.openKeyboard(false);
    }

    render() {
        const {keyboardVisible} = this.state;
        const {value, className, removedClassName, nonDecimal, stringAfter, label} = this.props;
        const cn = keyboardVisible ? className.replace(removedClassName, '') : className;
        const fractionDigits = nonDecimal ? 0 : 2;

        return (
            <div className={cn}>
                <div className="boxBtn-inner" onClick={() => this.openKeyboard(true)}>
                    <div>
                        <FormattedNumber style="decimal"
                                         maximumFractionDigits={fractionDigits}
                                         minimumFractionDigits={fractionDigits}
                                         value={value}/>
                        {!!stringAfter &&
                        <span> {stringAfter}</span>
                        }
                    </div>
                </div>
                {keyboardVisible &&
                <Numerical defaultValue={value}
                           label={label}
                           nonDecimal={nonDecimal}
                           onClose={() => this.openKeyboard(false)}
                           onSubmit={this.onSubmit}/>
                }
            </div>
        );
    }
}

export default connect(state => ({}))(NumericalButton);



// WEBPACK FOOTER //
// ./src/browser/components/keyboard/NumericalButton.js